export const colors = {
  LandingPage_Background: '#FFFFFF', // Branco para fundo
  LandingPage_Description: '#373737', // Escuro para descrição
  Button_Primary: '#DD7439', // Laranja (principal)
  Button_Secondary: '#4473B5', // Azul (principal)
  Header_Background: "#FFFFFF", // Branco para o fundo do cabeçalho
  Header_Content: '#000000', // Preto para conteúdo no cabeçalho
  Black: '#000000', // Preto
  Header: '#4473B5', // Azul (principal)
  Header_Text: "#FFFFFF", // Branco para texto no cabeçalho
  Header_Text_back: "#DD7439", // Laranja (principal) para o texto do cabeçalho
  Table_Header: '#DD7439', // Laranja (principal) para o cabeçalho da tabela
  Action_Button_Back: '#DD7439', // Laranja (principal) para botões de ação
  ALERT_BUTTON_GOTO_COLOR: "#c6e2f6", // Azul suave (para alerta)
  ALERT_BUTTON_CLOSE_COLOR:  "#ea969d", // Rosa suave para alerta
  HEADER: '#2a383b', // Escuro para o cabeçalho
  BORDER_BACKGROUND: "#d6d6d6", // Neutro para bordas
  CAR_BOX_EVEN:'#4473B5', // Azul (principal) para carros pares
  CAR_BOX_ODD:'#EDC147', // Amarelo (principal) para carros ímpares
  CARD_LABEL:"#4C5152", // Neutro para rótulos de cartão
  CARD_DETAIL:"#F5F5F5", // Fundo suave para detalhes de cartão
  STATUS_COMPLETE:"#2CDE3A", // Verde de status de conclusão
  STATUS_CANCELED:"#DF2E38", // Vermelho para status cancelado
  STATUS_PENDING:"#EDC147", // Amarelo (principal) para status pendente
  ROW_SELECTED:"#EEE", // Suave para linha selecionada
  TABLE_BORDER:"rgba(224, 224, 224, 1)", // Neutro para bordas da tabela
  SUB_2:"#019b9d", // Cor secundária suave
  WALLET_CARD:"#EDC147", // Cor para cartão de carteira
  WALLET_CARD_SHADOW:"#9E9E9E", // Sombra suave para o cartão
  FACEBOOK_COLOR:"#3b5998", // Azul para o Facebook
  BLUE:"#4473B5", // Azul (principal)
  TAXIPRIMARY: "#DD7439", // Laranja (principal) para o táxi
  TAXISECONDORY: "#4473B5", // Azul (principal) para o táxi
  DELIVERYPRIMARY: "#DD7439", // Laranja (principal) para a entrega
  DELIVERYSECONDORY: "#E7F1F9", // Azul suave para a entrega
  BIDTAXIPRIMARY: "#DD7439", // Laranja (principal) para o táxi
  BIDTAXISECONDORY: "#eee7ca", // Suave, neutro para o táxi
  TRANSPARENT: "transparent", // Transparente
  WHITE: "#ffffff", // Branco
  BLACK: "#000000", // Preto
  RED: "#FF1E00", // Vermelho
  GREEN: "#0CAB03", // Verde (para indicadores)
  YELLOW: "#EDC147", // Amarelo (principal)
  VIOLET:"#EDC147", // Roxo
  FOOTERTOP: "#cccccc", // Neutro para rodapé
}
